export default __webpack_public_path__ + "static/media/sketch.93a6da9f9dd4f654378985bf6bdede7b.svg";